import React, { useState, useEffect } from 'react';
import {
    MessageContainer,
    AvatarContainer,
    TextContainer,
    AuthorTypography,
    MessageTypography,
} from './styles';
import {
    IClientChatHistoryMessage,
    MessageTypes,
    TempMessageAndChatIds,
} from '../../../../common';
import { useAppSelector, Avatar } from '../../../../base';
import { userSelectors } from '../../../../actions';
import PargodaLoading from '../../../PargodaLoading';

export interface ChatMessageProps {
    message: IClientChatHistoryMessage;
    messageId: string;
    isLastMessage: boolean;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
    message,
    messageId,
    isLastMessage: _isLastMessage,
}) => {
    const userData = useAppSelector(userSelectors.getMyUser);

    const isAwaitingReply =
        messageId === TempMessageAndChatIds.TEMP_AWAITING_REPLY_MESSAGE_ID;

    const isAssistant = message.type === MessageTypes.ASSISTANT;

    const [displayedMessage, setDisplayedMessage] = useState('');

    const shouldAnimate = _isLastMessage && !isAwaitingReply && isAssistant;

    useEffect(() => {
        if (shouldAnimate) {
            let i = 0;
            const typingInterval = setInterval(() => {
                setDisplayedMessage(message.message.slice(0, i));
                i++;
                if (i > message.message.length) {
                    clearInterval(typingInterval);
                }
            }, 25);

            return () => {
                clearInterval(typingInterval);
            };
        } else {
            setDisplayedMessage(message.message);
        }
    }, [message.message, shouldAnimate]);

    return (
        <MessageContainer
            isAssistant={isAssistant}
            isAwaitingReply={isAwaitingReply}
        >
            <AvatarContainer>
                {isAwaitingReply ? (
                    <PargodaLoading height={40} width={40} />
                ) : (
                    <Avatar
                        src={isAssistant ? '/assets/iconColor.svg' : undefined}
                        name={`${userData?.firstName} ${userData?.lastName}`}
                    >
                        {message.type === MessageTypes.USER
                            ? `${userData?.firstName.charAt(
                                  0
                              )} ${userData?.lastName.charAt(0)}`
                            : 'P'}
                    </Avatar>
                )}
            </AvatarContainer>
            <TextContainer>
                <AuthorTypography variant="subtitle1">
                    {message.type === MessageTypes.USER
                        ? `${userData?.firstName} ${userData?.lastName}`
                        : 'Pargoda'}
                </AuthorTypography>
                <MessageTypography
                    variant="subtitle2"
                    sx={{
                        color: isAwaitingReply
                            ? 'text.disabled'
                            : 'text.secondary',
                    }}
                >
                    {displayedMessage}
                </MessageTypography>
            </TextContainer>
        </MessageContainer>
    );
};

export default ChatMessage;
